export default __webpack_public_path__ + "static/eow-logo-b54a00f12cb9af3e3b2b1aead1a36c78.png";